import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable()
export class DateInterceptor implements HttpInterceptor {

  constructor() { }
  private defaultDate = moment('0001-01-01T00:00:00Z', moment.ISO_8601);

  private isNumeric(value) {
    return /^-{0,1}\d+$/.test(value);
  }


  private convertDateStringsToDates(input: any) {
    // Ignore things that aren't objects.
    if (typeof input !== "object") return input;

    for (const key in input) {
      if (!input.hasOwnProperty(key)) continue;

      const value = input[key];

      // Check for string properties which look like dates.
      const md = moment.utc(value, moment.ISO_8601);
      if (typeof value === "string" && md.isValid() && !this.isNumeric(value.toString())) {
        if (md.isSame(this.defaultDate)) {
          input[key] = null;
        } else {
          input[key] = md.toDate();
        }
      } else if (typeof value === "object") {
        // Recurse into object
        this.convertDateStringsToDates(value);
      }
    }
  }

  private convertDatesToStrings(input: any) {
    // Ignore things that aren't objects.
    if (typeof input !== "object") return input;

    for (const key in input) {
      if (!input.hasOwnProperty(key)) continue;

      const value = input[key];
      // Check for date properties
      if (value && value.getMonth && typeof value.getMonth === 'function') {
        input[key] = (<Date>value).toISOString();
      } else if (typeof value === "object") {
        // Recurse into object
        this.convertDatesToStrings(value);
      }
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!!request.body) {
      //This part of the interceptor handles only requests to the server
      this.convertDatesToStrings(request.body);
    }

    return next.handle(request).pipe(map(resp => {
      //This part of the interceptor handles only responses from the server
      if (resp instanceof HttpResponse) {
        this.convertDateStringsToDates(resp);
      }
      return resp;
    }));
  }
}
